import { LightButton, PrimaryButton } from "components/buttons/buttons";
import RadioGroupControl from "components/controls/radio-group-control/radio-group-control";
import Modal from "components/modals/modal/modal";
import { ModalProps } from "core/utils/modals";
import flow from "lodash/flow";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { ActionHandler, RadioGroupItem } from "types";
import { apply, empty, notNil } from "../../../../core/utils";
import "./elegir-forma-pago.modal.scss";

const formasPago: RadioGroupItem[] = [
	{ value: "1", label: "Pago en efectivo" },
	{ value: "2", label: "Transferencia desde Banca en Línea" },
	{ value: "3", label: "Transferencia a Cuenta/CLABE digital" },
	{ value: "4", label: "Pago con Banca Electrónica Banorte" },
	{ value: "5", label: "Pago desde cuenta de cheques a través de la CLABE" },
	{ value: "6", label: "Pago con Tarjeta de Crédito o Débito" },
];

type FormaSeleccion = { formaPago: string; };

export type ElegirFormaPagoModalProps = ModalProps & {
	formasPago: string[];
	onAccept: ActionHandler<string>;
};

export const ElegirFormaPagoModal = (props: ElegirFormaPagoModalProps) => {
	const methods = useForm<FormaSeleccion>();
	const [disabled, setDisabled] = useState(true);
	const formasPagoDisponibles = formasPago.filter(x => props.formasPago.includes(x.value))

	const consultar = (close: VoidFunction) => ({ formaPago }: FormaSeleccion) => {
		if (notNil(formaPago)) {
			props.onAccept(formaPago);
			close();
		}
	};

	const footer = (close: VoidFunction) => (
		<>
			<LightButton onClick={flow(props.onClosed ?? empty, close)}>Cancelar</LightButton>
			<PrimaryButton disabled={disabled} onClick={methods.handleSubmit(consultar(close))}>Pagar</PrimaryButton>
		</>
	);

	return (
		<Modal parent={props.parent} title="Elige la forma de pago" footer={footer} dialogClassName="elegir-forma-pago" onClosed={props.onClosed}>
			<div className="ms-5">
				<RadioGroupControl
					name="formaPago"
					items={formasPagoDisponibles}
					formMethods={methods}
					onChange={apply(setDisabled, false)}
					required
				/>
			</div>
		</Modal>
	);
};

export default ElegirFormaPagoModal;